export const cpfMask = (value: string): string => {
  const numericValue = value.replace(/\D/g, '').slice(0, 11);

  return numericValue.replace(
    /(\d{3})(\d{3})?(\d{3})?(\d{0,2})/, 
    (_, p1, p2, p3, p4) => {
      let mask = p1;
      if (p2) mask += `.${p2}`;
      if (p3) mask += `.${p3}`;
      if (p4) mask += `-${p4}`;
      return mask;
    }
  );
};

export const rgMask = (value: string): string => {
  const numericValue = value.replace(/\D/g, '').slice(0, 8);

  return numericValue.replace(
    /(\d{2})(\d{3})?(\d{3})?(\d{0,1})/, 
    (_, p1, p2, p3, p4) => {
      let mask = p1;
      if (p2) mask += `.${p2}`;
      if (p3) mask += `.${p3}`;
      if (p4) mask += `-${p4}`;
      return mask;
    }
  );
};

export const cellphoneMask = (phoneNumber: string): string => {
  const numericValue = phoneNumber.replace(/\D/g, '').slice(0, 11);
  const qtd = numericValue.length === 10 ? 4 : 5;
  if (qtd === 4) {
    return numericValue.replace(/(\d{2})(\d{0,4})(\d{0,4})/, (match, p1, p2, p3) => {
      let result = `(${p1}`;

      if (p2) result += `) ${p2}`;
      if (p3) result += `-${p3}`;

      return result;
    });
  } else {
    return numericValue.replace(/(\d{2})(\d{0,5})(\d{0,4})/, (match, p1, p2, p3) => {
      let result = `(${p1}`;

      if (p2) result += `) ${p2}`;
      if (p3) result += `-${p3}`;

      return result;
    });
  }
};